import { forwardRef, memo } from 'react';
import { CustomActionDiscriminator } from 'autogen/swagger/all';
import CertificationAction from './components/CertificationAction';
import JavascriptHookActionRenderer from './components/JavascriptHookActionRenderer';
import LiveEventAction from './components/LiveEventAction';
import SurveyAction from './components/SurveyAction';
import VimeoAction from './components/VimeoAction';
import type { CustomActionProps } from './shared/types';

const CustomAction = forwardRef<HTMLButtonElement, CustomActionProps>(({ action, ...restProps }, ref) =>
    CustomActionDiscriminator(
        action,
        (certificationAction) => <CertificationAction action={certificationAction} ref={ref} {...restProps} />,
        (javascriptHookAction) => (
            <JavascriptHookActionRenderer action={javascriptHookAction} ref={ref} {...restProps} />
        ),
        (liveEventAction) => <LiveEventAction action={liveEventAction} ref={ref} {...restProps} />,
        (surveyAction) => <SurveyAction action={surveyAction} ref={ref} {...restProps} />,
        (vimeoAction) => <VimeoAction action={vimeoAction} ref={ref} {...restProps} />,
        () => {
            throw new Error('Invalid Custom Action');
        }
    )
);

export default memo(CustomAction);
